if (!customElements.get("product-info")) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define("product-info", ProductInfo);
}

document.addEventListener('DOMContentLoaded', () => {
  const backLink = document.querySelector('[data-back-link]');
  if (!backLink) return;

  const fallback =
    backLink.getAttribute('data-fallback') ||
    '/collections';

  const isSameOrigin = (url) => {
    try { return new URL(url).origin === location.origin; } catch (_) { return false; }
  };

  const isCollectionUrl = (url) => {
    try { return new URL(url).pathname.startsWith('/collections/'); } catch (_) { return false; }
  };

  // Nur wenn Referrer wirklich eine Collection ist
  if (document.referrer && isSameOrigin(document.referrer) && isCollectionUrl(document.referrer)) {
    backLink.setAttribute('href', document.referrer);
  } else {
    // Suche, Direktlink, externe Seite → Fallback
    backLink.setAttribute('href', fallback);
  }
});